/**
 * שקלים — פעם אחת.
 *
 * ── מה שנמדד 07/09/2026 ─────────────────────────────────────────────────
 *
 * שנים-עשר קבצים הגדירו כל אחד לעצמו `ils` / `money` / `shekel`, בשלוש
 * גרסאות שונות:
 *
 *   ₪${Math.round(n).toLocaleString('he-IL')}                   ← תשעה
 *   ₪${n.toLocaleString('he-IL', { maximumFractionDigits: 2 })} ← אחד
 *   ₪${n.toLocaleString('he-IL')}                               ← אחד
 *
 * כלומר ₪1,234.5678 נכתב „₪1,235“ במסך אחד, „₪1,234.57“ בשני, ו-
 * „₪1,234.5678“ בשלישי. אלי: „לא פחות חשוב ההמשכיות של הפריטים בכל
 * המסכים“ — ואותו סכום שנראה שונה בשלושה מסכים הוא בדיוק זה.
 *
 * ── הכלל שנבחר ──────────────────────────────────────────────────────────
 *
 * אגורות מוצגות **רק כשהן קיימות**. מחיר כבל הוא ₪62.50 ונשאר כך; סכום
 * של ₪3,585 אינו הופך ל-„₪3,585.00“. שום ספרה אמיתית אינה נעלמת, ושום
 * אפס שאין בו מידע אינו מודפס.
 *
 * `null` הוא „לא ידוע“ ומוחזר כמקף — לא כ-₪0. זה כלל מוצר, לא עיצוב:
 * מחיר שלא נקבע ואפס שקלים הם שני דברים שונים.
 */
export function ils(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  const agorot = Math.abs(n * 100 - Math.round(n * 100)) < 0.5 && Math.round(n * 100) % 100 !== 0;
  return `₪${n.toLocaleString('he-IL', {
    minimumFractionDigits: agorot ? 2 : 0,
    maximumFractionDigits: agorot ? 2 : 0,
  })}`;
}

/** כשהמספר הוא סכום גדול שאגורות בו הן רעש — דוחות והשוואות. */
export function ilsRound(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  return `₪${Math.round(n).toLocaleString('he-IL')}`;
}
